export enum AuthResult {
  Success,
  ServerError,
}
